import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { ShopPack } from '../shop-pack.model';

@JsonObject('ShopPacksResultsResponse')
export class ShopPacksResultsResponse extends ApiResultsResponse<ShopPack> {

  @JsonProperty('results', [ShopPack])
  override results: ShopPack[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
